import styled, { css } from 'styled-components'

const OptionSize = 56

export const Container = styled.div`
  position: relative;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .text-dropdown--button-area {
    background: none;
    border: 0;

    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    width: 100%;

    display: flex;
    gap: 14px;
    align-items: center;
    justify-content: space-between;

    background: ${({ theme }) => `rgb(${theme.background.high})`};

    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

    border-radius: 4px;

    padding: 10px;

    @media only screen and (min-width: 700px) {
      padding: 18px 20px;
    }

    transition: filter 0.3s ease;

    &:hover {
      filter: brightness(0.98);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;

      &:hover {
        filter: brightness(0.9);
      }
    }

    .wrap {
      display: flex;
      align-items: center;
      justify-content: start;

      gap: 8px;

      width: 88%;
    }

    .text-dropdown--button-label {
      font-weight: 700;
      font-size: 0.875rem;

      display: inline-block;

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      margin: 0;
    }
  }
`

export const Dropdown = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  z-index: 10;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  border-radius: 4px;

  display: flex;
  flex-direction: column;

  transform: translateY(calc(100% + 6px));

  max-height: ${OptionSize * 3.5}px;

  overflow-y: auto;
`

export const Option = styled.button<{ isSelected: boolean }>`
  position: relative;

  padding: 12px 6px !important;

  @media only screen and (min-width: 700px) {
    padding: 18px 16px;
  }

  background: none;
  border: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  max-width: 100%;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  transition: filter 0.3s ease;

  &:hover {
    filter: brightness(0.96);
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: #e6e6e6;

      background: ${({ theme }) => `rgba(${theme.grayscale[400]}, 0.8)`};
    `}

  .text-dropdown--dropdown-label {
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    font-weight: 700;
    font-size: 0.875rem;

    display: inline-block;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    margin-left: 8px;
  }
`
